import * as React from 'react';
import FlightSwitch from '../../../components/FlightSwitch/FlightSwitch';
import { PerPersonPriceBig } from '../../../components/PerPersonPriceBig';
import { Urgency } from '../../../components/Urgency';
import { hasHotelServiceCharges } from '../../../helpers/hotelServiceChargesHelper';
import { priceAvailability } from '../../../helpers/priceHelpers';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { CTABanner } from '../../RequestForm/components/CTABanner';
import { config } from '../../../config';
import ScrollToBtn from '../../../components/ScrollToBtn/ScrollToBtn';
import { __ } from '../../../helpers/TranslationService';
import styled from '@emotion/styled';
export interface ICruisePriceSection {
    startHarbour?: string;
    endHarbour?: string;
    requestFormBtnUrl: string;
    cabinSectionRef?: any;
}

const CruisePriceSelectionWrapper = styled.div`
    margin-bottom: -15px;
    background-color: white;
`;

const ScrollToButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 12px 16px;
`;

const CruisePriceSectionMobile = (props: ICruisePriceSection) => {
    const { pageData, cruisePage, ui } = useTypedSelector((state) => state);
    const { isLoadingGlobal } = ui;

    if (isLoadingGlobal) return null;
    const {
        minPrice,
        currency,
        soldOutBooking,
        sails,
        selectedSailIndex,
        includesFlight,
        alternativeCruise,
        loadingRates,
    } = cruisePage;

    const { startHarbour, endHarbour } = props;
    const isAlternativeCruise = alternativeCruise !== undefined;
    const alternativeCruiseUrl = alternativeCruise?.url;

    const selectedSail = sails[selectedSailIndex];

    const isDesktop = pageData.deviceType === 'desktop';
    const shouldShowBPG = pageData.appConfig.countryCode === 'de';

    const maxDiscount = cruisePage.maxDiscount > 0 ? cruisePage.maxDiscount : 0;
    const departure = selectedSail?.departure || undefined;
    const pricing = priceAvailability(departure, soldOutBooking, minPrice, currency);

    const cabinList = cruisePage.cabins.map((cabin) => {
        return { ...cabin.cabinType, perPersonPrice: cabin.perPersonPrice };
    });
    const cheapestCabinNid = cruisePage.cheapestCabinNidForSail;
    const cabin = cabinList.find((cabin) => cabin.nid === cheapestCabinNid);

    const hotelServiceChargesLabel = hasHotelServiceCharges(
        pageData.appConfig.countryCode,
        cruisePage.company.title,
        cruisePage.ship.title,
        departure,
    );

    return (
        <>
            {!isDesktop && (
                <CruisePriceSelectionWrapper>
                    <div className="cruisePageSection" style={{ paddingBottom: 0 }}>
                        {isAlternativeCruise && (
                            <FlightSwitch
                                startHarbour={startHarbour}
                                endHarbour={endHarbour}
                                includesFlight={includesFlight}
                                url={alternativeCruiseUrl}
                            />
                        )}
                    </div>
                    {loadingRates && (
                        <div className="overview-price-component__placeholder__loading full-width">
                            <img alt="price loading" src={`${config.images}/common/loading.gif`} />
                        </div>
                    )}
                    {!loadingRates && (
                        <PerPersonPriceBig
                            price={pricing.string}
                            discount={maxDiscount}
                            onRequest={!pricing.valid}
                            cabin={cabin?.kindName}
                            discountThreshold={pageData.discountThreshold}
                            discountType="top"
                            withFlight={includesFlight}
                            hasHotelServiceCharges={hotelServiceChargesLabel}
                            market={pageData.brandConfig.portalId}
                        />
                    )}
                    <ScrollToButtonWrapper>
                        <ScrollToBtn
                            title={__('Dates and Prices', 'dreamlines')}
                            anchorSelector="#cabinTable"
                            disabled={cruisePage.sails.length === 0}
                            isMobile={!isDesktop}
                        />
                    </ScrollToButtonWrapper>
                    {shouldShowBPG && <CTABanner />}
                    <Urgency
                        countryCode={pageData.appConfig.countryCode}
                        cruisePage={cruisePage}
                        stockThreshold={pageData.stockThreshold}
                        isDreamlinesPackage={cruisePage.operator.isDreamlinesPackage}
                        background="white"
                        OBCBlacklist={pageData.obc?.blacklist}
                    />
                </CruisePriceSelectionWrapper>
            )}
        </>
    );
};
export default CruisePriceSectionMobile;
